define('gamebox', ['exports', 'module', './assetloader', './input', './loop', './log', './timer', './math', './types'], function (exports, module, _assetloader, _input, _loop, _log, _timer, _math, _types) {
  'use strict';

  function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }

  var _AssetLoader = _interopRequire(_assetloader);

  var _Input = _interopRequire(_input);

  var _Loop = _interopRequire(_loop);

  var _Log = _interopRequire(_log);

  var _Timer = _interopRequire(_timer);

  var _Math = _interopRequire(_math);

  var _Types = _interopRequire(_types);

  'use strict';

  module.exports = {
    AssetLoader: _AssetLoader,
    Input: _Input,
    Loop: _Loop,
    Log: _Log,
    Timer: _Timer,
    Math: _Math,
    Types: _Types
  };
});